module.exports = __webpack_public_path__ + "img/apoio-sti.82bfc6d8.png";